import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar-user-container" }
const _hoisted_2 = { class: "user-logo-container cursor-pointer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_NavBarUserMenu = _resolveComponent("NavBarUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_avatar, { color: "#313336" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.getInitials()), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_NavBarUserMenu)
  ]))
}